<template>
  <form ref="fileform" style="height: 100%">
    <!-- slot for parent component to activate the file changer -->
    <span @click.stop="launchFilePicker()">
      <slot name="activator"></slot>
    </span>
    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->

    <input
      type="file"
      ref="file"
      :accept="`${type}/*`"
      :key="keyUploadImage"
      :name="uploadFieldName"
      @change="onFileChange($event.target.name, $event.target.files)"
      style="display: none"
    />
  </form>
</template>
<script>
export default {
  name: "Upload",
  store: ["app"],
  data: () => ({
    uploadFieldName: "file",
    size: 1024,
    keyUploadImage: 0,
  }),
  watch: {
    value: function () {
      this.keyUploadImage++;
    },
    overlay: function (val) {
      console.log("vall: ", val);
    },
  },
  // Use "value" here to enable compatibility with v-model
  props: ["value", "type", "loadding", "maxHeight", "maxWidth", "overlay"],
  mounted() {
    /*
        Determine if drag and drop functionality is capable in the browser
      */
    this.dragAndDropCapable = this.determineDragAndDropCapable();

    /*
        If drag and drop capable, then we continue to bind events to our elements.
      */
    // if (this.dragAndDropCapable) {
    //   /*
    //       Listen to all of the drag events and bind an event listener to each
    //       for the fileform.
    //     */
    //   [
    //     "drag",
    //     "dragstart",
    //     "dragend",
    //     "dragover",
    //     "dragenter",
    //     "dragleave",
    //     "drop"
    //   ].forEach(
    //     function(evt) {
    //       /*
    //         For each event add an event listener that prevents the default action
    //         (opening the file in the browser) and stop the propagation of the event (so
    //         no other elements open the file in the browser)
    //       */
    //       this.$refs.fileform.addEventListener(
    //         evt,
    //         function(e) {
    //           e.preventDefault();
    //           e.stopPropagation();
    //         }.bind(this),
    //         false
    //       );
    //     }.bind(this)
    //   );

    //   /*
    //       Add an event listener for drop to the form
    //     */
    //   this.$refs.fileform.addEventListener(
    //     "drop",
    //     function(e) {
    //       /*
    //         Capture the files from the drop event and add them to our local files
    //         array.
    //       */
    //       this.onFileChange(e.dataTransfer.files[0].name, e.dataTransfer.files);
    //     }.bind(this)
    //   );
    // }
  },
  methods: {
    determineDragAndDropCapable() {
      /*
          Create a test element to see if certain events
          are present that let us do drag and drop.
        */
      var div = document.createElement("div");

      /*
          Check to see if the `draggable` event is in the element
          or the `ondragstart` and `ondrop` events are in the element. If
          they are, then we have what we need for dragging and dropping files.

          We also check to see if the window has `FormData` and `FileReader` objects
          present so we can do our AJAX uploading
        */
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    getExtension(filename) {
      var parts = filename.split(".");
      return parts[parts.length - 1];
    },
    isImage(filename) {
      var ext = this.getExtension(filename);
      switch (ext.toLowerCase()) {
        case "jpg":
        case "jpeg":
        case "png":
        case "svg":
          return true;
      }
      return false;
    },
    isVideo(filename) {
      var ext = this.getExtension(filename);
      switch (ext.toLowerCase()) {
        case "mp4":
        case "webm":
          return true;
      }
      return false;
    },
    isAudio(filename) {
      var ext = this.getExtension(filename);
      switch (ext.toLowerCase()) {
        case "mp3":
        case "wav":
          return true;
      }
      return false;
    },
    onFileChange(fieldName, file) {
      let fileUpload = file[0];
      const { isImage, isVideo, isAudio } = this;
      //check if user actually selected a file
      if (file.length > 0) {
        const sizeCheck = Number(
          (fileUpload.size / (this.size * this.size)).toFixed(2)
        );
        const fileName = fileUpload.name;
        // check whether the upload is an image
        if (this.type == "image") {
          if (!isImage(fileName)) {
            return this.$toast.error(
              "「JPG、JPEG、PNG、SVG」拡張子の画像を選択してください"
            );
          }
          if (sizeCheck > 5) {
            return this.$toast.error("ファイルサイズは5MB以下にしてください。");
          }
        }
        // check whether the upload is an video
        if (this.type == "video") {
          if (!isVideo(fileName)) {
            return this.$toast.error(
              "「MP4, WEBM」拡張子の動画を選択してください。"
            );
          }
          if (sizeCheck > 50) {
            return this.$toast.error(
              "ファイルサイズは50MB以下にしてください。"
            );
          }
        }
        if (this.type == "audio") {
          if (!isAudio(fileName)) {
            return this.$toast.error(
              "「MP3、WAV」拡張子の音声を選択してください。"
            );
          }
          if (sizeCheck > 30) {
            return this.$toast.error(
              "ファイルサイズは30MB以下にしてください。"
            );
          }
        }
        // Append file into FormData & turn file into image URL
        let formData = new FormData();
        let fileUrl = URL.createObjectURL(fileUpload);
        formData.append(fieldName, fileUpload);
        this.$emit("input", { fileUrl, file: file[0], formData });
        this.keyUploadImage++;
      }
    },
    cancelImg() {
      this.keyUploadImage++;
      this.$emit("input", null);
    },
  },
};
</script>
